import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../Layout";
import ToggleButton from "../../../components/formComponents/ToggleButton";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { validationSchema, industries } from "./validationSchema";
import ImgDrop from "../../../assets/na7p8lprxplx309m10.png";
import { Link, useOutletContext, useParams } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import * as Unicons from "@iconscout/react-unicons";
import {
  GetState,
  GetCity, //async functions
} from "react-country-state-city";
import { set } from "react-hook-form";
import { getAxiosConfig, getMinioSize } from "../../../utils/helpers";
import ImgOptimized from "../../../components/ImgOptimized";
import useRole from "../../../utils/useRole";
import MyToggle from "../../../components/MyToggle";
import SortableImagePreviewer from "./SortableImagePreviewer";

const MAX_FEATURED_IMAGES = 5;

const ProjectShowcaseAdd = () => {
  let initialFormData = {
    title: "",
    isFavorite: false,
    buildingName: "",
    subTitle: "",
    spaceSize: 0,
    location: {
      state: "",
      city: "",
    },
    industry: "",
    virtualLink: [],
    youtubeLink: "",
    sliderImages: [], // For slider images
    beforeAfterImages: [],
    thumbNail: [],
    featuredImages: [],
    textSection: [
      {
        title: "",
        subTitle: "",
        description: "",
        textSectionImgs: [], // For text section images
        isActive: false,
      },
    ],
    isLive: false,
    otp: "",
  };
  // console.log("EDIT");
  const { projectData, fetchProject } = useOutletContext();
  const [formData, setFormData] = useState(initialFormData);
  const [isOtpPopupActive, setIsOtpPopupActive] = useState(false);

  // console.log("Project Data:", projectData);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeComparisonSlot, setActiveComparisonSlot] = useState(null); // {compIndex, slotIndex}
  const [isThumbNailOpen, setIsThumbNailOpen] = useState(false);
  const [isFeaturedOpen, setIsFeaturedOpen] = useState(false);
  const [isImageSelectorOpen, setIsImageSelectorOpen] = useState(false); // State to manage popup visibility
  const [isTextSectionImageSelectorOpen, setIsTextSectionImageSelectorOpen] =
    useState(false); // State to manage popup visibility
  const [currentSectionIndex, setCurrentSectionIndex] = useState(null);
  const { id } = useParams();

  // Helpers for multi-comparison before/after
  const getComparisonsCount = () =>
    Math.max(1, Math.ceil((formData.beforeAfterImages || []).length / 2));

  const getComparisonImages = (compIndex) => {
    const imgs = formData.beforeAfterImages || [];
    return [imgs[compIndex * 2] || null, imgs[compIndex * 2 + 1] || null];
  };

  const setComparisonSlot = (compIndex, slotIndex, imageValue) => {
    setFormData((prevData) => {
      const imgs = [...(prevData.beforeAfterImages || [])];
      const flatIndex = compIndex * 2 + slotIndex;
      // Ensure array is long enough
      while (imgs.length <= flatIndex) imgs.push(null);
      imgs[flatIndex] = imageValue;
      return { ...prevData, beforeAfterImages: imgs };
    });
  };

  const addComparison = () => {
    setFormData((prevData) => ({
      ...prevData,
      beforeAfterImages: [...(prevData.beforeAfterImages || []), null, null],
    }));
  };

  const removeComparison = (compIndex) => {
    setFormData((prevData) => {
      const imgs = [...(prevData.beforeAfterImages || [])];
      imgs.splice(compIndex * 2, 2);
      return { ...prevData, beforeAfterImages: imgs };
    });
  };

  const validateComparisons = () => {
    const compCount = getComparisonsCount();
    const errs = {};
    for (let i = 0; i < compCount; i++) {
      const [a, b] = getComparisonImages(i);
      if ((a && !b) || (!a && b)) {
        errs[`comparison_${i}`] =
          `Comparison ${i + 1} must have both images or none.`;
      }
    }
    return errs;
  };

  // useEffect(() => {
  //   const fetchProject = async () => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_BACK_URL}/api/project-showcases/${id}`);
  //       setFormData((prev) => ({
  //         ...prev,
  //         ...response.data,
  //       }));
  //     } catch (error) {
  //       console.error("Failed to fetch project data", error);
  //     }
  //   };

  //   fetchProject();
  // }, [id]);

  const addVirtualLink = () => {
    setFormData((prevData) => ({
      ...prevData,
      virtualLink: [...(prevData.virtualLink || []), ""],
    }));
  };

  const removeVirtualLink = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      virtualLink: (prevData.virtualLink || []).filter((_, i) => i !== index),
    }));
  };

  const handleVirtualLinkChange = (value, index) => {
    setFormData((prevData) => {
      const updated = [...(prevData.virtualLink || [])];
      updated[index] = value;
      return {
        ...prevData,
        virtualLink: updated,
      };
    });
  };

  useEffect(() => {
    if (projectData) {
      let vLink = projectData.virtualLink;
      if (typeof vLink === "string") {
        vLink = vLink ? [vLink] : [];
      } else if (!Array.isArray(vLink)) {
        vLink = [];
      }
      setFormData((prev) => ({
        ...prev,
        ...projectData,
        virtualLink: vLink,
      }));
    }
  }, [projectData]);
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSectionChange = (e, index, field) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      textSection: prevData.textSection.map((section, idx) =>
        idx === index ? { ...section, [field]: value } : section,
      ),
    }));
  };

  const handleToggle = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      textSection: prevData.textSection.map((section, idx) =>
        idx === index ? { ...section, isActive: !section.isActive } : section,
      ),
    }));
  };

  const addSection = () => {
    setFormData((prevData) => ({
      ...prevData,
      textSection: [
        ...prevData.textSection,
        {
          title: "",
          subTitle: "",
          description: "",
          textSectionImgs: [],
          isActive: false,
        },
      ],
    }));
  };

  const removeSection = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      textSection: prevData.textSection.filter((_, idx) => idx !== index),
    }));
  };

  const removeImage = (index, isSliderImage = 1, sectionIndex = null) => {
    if (isSliderImage == 1) {
      setFormData((prevData) => ({
        ...prevData,
        sliderImages: prevData.sliderImages.filter(
          (_, imgIndex) => imgIndex !== index,
        ),
      }));
    } else if (isSliderImage == 2) {
      setFormData((prevData) => ({
        ...prevData,
        beforeAfterImages: prevData.beforeAfterImages.filter(
          (_, imgIndex) => imgIndex !== index,
        ),
      }));
    } else if (isSliderImage == 3) {
      setFormData((prevData) => ({
        ...prevData,
        thumbNail: prevData.thumbNail.filter(
          (_, imgIndex) => imgIndex !== index,
        ),
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        textSection: prevData.textSection.map((section, idx) =>
          idx === sectionIndex
            ? {
                ...section,
                textSectionImgs: section.textSectionImgs.filter(
                  (_, imgIndex) => imgIndex !== index,
                ),
              }
            : section,
        ),
      }));
    }
  };

  const handleImageSelectionChange = (selectedImages, isSliderImage) => {
    if (isSliderImage === 1) {
      setFormData((prevData) => ({
        ...prevData,
        sliderImages: selectedImages,
      }));
    } else if (isSliderImage === 2) {
      setFormData((prevData) => ({
        ...prevData,
        beforeAfterImages: selectedImages,
      }));
    } else if (isSliderImage === 3) {
      setFormData((prevData) => ({
        ...prevData,
        thumbNail: selectedImages,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        textSection: prevData.textSection.map((section, idx) => {
          if (idx === currentSectionIndex) {
            return { ...section, textSectionImgs: selectedImages };
          }
          return section;
        }),
      }));
    }
  };

  const postData = async (toastId) => {
    try {
      const payload = {
        ...formData,
        virtualLink: (formData.virtualLink || []).filter(
          (link) => link && typeof link === "string" && link.trim() !== "",
        ),
      };
      const response = await axios.put(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases/${id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("usersdatatoken"),
          },
        },
      );
      if (response.status === 200) {
        toast.update(toastId, {
          render: "Project saved successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
        setErrors({});
        console.log("Project showcase saved:", response.data);
        setIsOtpPopupActive(false);
        const resData = response.data;
        let vLink = resData.virtualLink;
        if (typeof vLink === "string") {
          vLink = vLink ? [vLink] : [];
        } else if (!Array.isArray(vLink)) {
          vLink = [];
        }
        setFormData((p) => ({
          ...p,
          ...resData,
          virtualLink: vLink,
          otp: "",
        }));
        if (fetchProject) {
          fetchProject();
        }
      }
    } catch (error) {
      toast.update(toastId, {
        render:
          error?.response?.data?.message ||
          error?.message ||
          "There was an error saving the project showcase!",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      console.error("There was an error saving the project showcase!", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (isSubmitting) return;

    try {
      // Validate comparison pairs first
      const compErrors = validateComparisons();
      if (Object.keys(compErrors).length > 0) {
        setErrors((prev) => ({ ...prev, ...compErrors }));
        toast.error("Please fix Render vs Actual comparison errors");
        return;
      }

      await validationSchema.validate(formData, { abortEarly: false });

      setIsSubmitting(true);
      const toastId = toast.loading("Saving project...");
      await postData(toastId);
    } catch (error) {
      setIsSubmitting(false);
      if (error instanceof Yup.ValidationError) {
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
        toast.error(
          error.errors?.[0] || "Please fill in all required fields correctly.",
        );
        console.log(validationErrors);
      } else {
        toast.error(error?.message || "An unexpected error occurred.");
      }
    }
  };

  const openTextSectionImageSelector = (index) => {
    setCurrentSectionIndex(index);
    setIsTextSectionImageSelectorOpen(true);
  };

  const closeTextSectionImageSelector = () => {
    setCurrentSectionIndex(null);
    setIsTextSectionImageSelectorOpen(false);
  };

  const openImageSelector = () => {
    setIsImageSelectorOpen(true);
  };

  const closeImageSelector = () => {
    setIsImageSelectorOpen(false);
  };

  const openBeforeAfterSlot = (compIndex, slotIndex) => {
    setActiveComparisonSlot({ compIndex, slotIndex });
  };

  const closeBeforeAfterSlot = () => {
    setActiveComparisonSlot(null);
  };

  const openThumbNail = () => {
    setIsThumbNailOpen(true);
  };

  const closeThumbNail = () => {
    setIsThumbNailOpen(false);
  };

  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    GetState(101).then((result) => {
      setStateList(result);
    });
    const state = stateList.find(
      (state) => state.name === formData.location.state,
    );
    GetCity(101, state?.id).then((result) => {
      setCityList(result);
    });
  }, [formData.location]);

  const handleStateChange = (e) => {
    const state = stateList.find((state) => state.name === e.target.value);
    setFormData((prevData) => ({
      ...prevData,
      location: {
        ...prevData.location,
        state: e.target.value,
        city: "",
      },
    }));
    GetCity(101, state.id).then((result) => {
      setCityList(result);
    });
  };

  const handleTagChange = (imagePath, newTag) => {
    setFormData((prevData) => {
      const currentTags = prevData.imageTags || [];
      const tagIndex = currentTags.findIndex((t) => t.image === imagePath);
      let updatedTags;

      if (!newTag || newTag === "untagged") {
        updatedTags = currentTags.filter((t) => t.image !== imagePath);
      } else if (tagIndex > -1) {
        updatedTags = currentTags.map((t, idx) =>
          idx === tagIndex ? { ...t, tag: newTag } : t,
        );
      } else {
        updatedTags = [...currentTags, { image: imagePath, tag: newTag }];
      }
      return {
        ...prevData,
        imageTags: updatedTags,
      };
    });
  };

  return (
    <div>
      <div className="p-3 mx-auto container bg-slate-50">
        <h1 className="text-2xl mt-3 mb-8">Create Project</h1>
        {/* <div className="flex justify-between items-center mt-3 mb-8">
          <h1 className="text-2xl font-bold">Create Project</h1>
          {id && (
            <Link to={`/project-showcase/${id}/edit/projects/re-upload`}>
              <button
                type="button"
                className="bg-primary-500 hover:bg-primary-600 text-white font-medium py-2 px-4 rounded-lg text-sm flex items-center gap-2 shadow transition-colors"
              >
                <Icon icon="ic:baseline-plus" className="text-lg" />
                Upload More Images (Test)
              </button>
            </Link>
          )}
        </div> */}
        <form onSubmit={handleSubmit}>
          {/* Top Information Section */}
          <div className="px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border">
            <h2 className="mb-3 text-lg font-bold">Top Information</h2>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-semibold block mb-2 tracking-wider">
                    Project Title <span className="text-red-500">*</span> :{" "}
                  </label>
                  <input
                    className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                    value={formData?.title}
                    onChange={(e) => handleInputChange(e, "title")}
                    placeholder="Enter project Title..."
                  />
                  {errors.title && (
                    <p className="text-red-500 text-xs px-2 pt-1">
                      {errors.title}
                    </p>
                  )}
                </div>
                <div>
                  <label className="text-sm font-semibold block mb-2 tracking-wider">
                    Project Sub Title <span className="text-red-500">*</span>{" "}
                    :{" "}
                  </label>
                  <input
                    className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                    value={formData?.subTitle}
                    onChange={(e) => handleInputChange(e, "subTitle")}
                    placeholder="Enter project Subheading..."
                  />
                  {errors.subTitle && (
                    <p className="text-red-500 text-xs px-2 pt-1">
                      {errors.subTitle}
                    </p>
                  )}
                </div>
                <div>
                  <label className="text-sm font-semibold block mb-2 tracking-wider">
                    Project Space Size
                    {/* <span className="text-red-500">*</span>{" "} */}:{" "}
                  </label>
                  <input
                    type="number"
                    className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                    value={formData?.spaceSize}
                    onChange={(e) => handleInputChange(e, "spaceSize")}
                    placeholder="Enter space size..."
                  />
                  {errors.spaceSize && (
                    <p className="text-red-500 text-xs px-2 pt-1">
                      {errors.spaceSize}
                    </p>
                  )}
                </div>
                <div>
                  <label className="text-sm font-semibold block mb-2 tracking-wider">
                    Building Name :{" "}
                  </label>
                  <input
                    className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                    value={formData?.buildingName || ""}
                    onChange={(e) => handleInputChange(e, "buildingName")}
                    placeholder="Enter building name..."
                  />
                  {errors.buildingName && (
                    <p className="text-red-500 text-xs px-2 pt-1">
                      {errors.buildingName}
                    </p>
                  )}
                </div>

                <div>
                  <label className="text-sm font-semibold block mb-2 tracking-wider">
                    Project Industry
                    {/* <span className="text-red-500">*</span>{" "} */}:{" "}
                  </label>
                  <select
                    className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                    value={formData.industry}
                    onChange={(e) => handleInputChange(e, "industry")}
                  >
                    <option value="" disabled>
                      Select industry
                    </option>
                    {industries.map((industry, idx) => (
                      <option key={idx} value={industry}>
                        {industry}
                      </option>
                    ))}
                  </select>
                  {errors.industry && (
                    <p className="text-red-500 text-xs px-2 pt-1">
                      {errors.industry}
                    </p>
                  )}
                </div>

                <div className="px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border">
                  <div className="flex justify-between items-center p-2 rounded-lg bg-white mb-4 border">
                    <h2 className="text-sm font-semibold">
                      Thumbnail Image <span className="text-red-500">*</span>
                    </h2>
                    <button
                      className="bg-teal-500 py-2 px-3 rounded-lg text-white text-xs"
                      type="button"
                      onClick={openThumbNail}
                    >
                      Choose Images
                    </button>
                  </div>

                  <ImagePreviewer
                    images={formData.projectImages}
                    grid={4}
                    isSingle={true}
                    selectedImages={formData.thumbNail}
                    removeImage={(index) => removeImage(index, 3)}
                  />
                  {errors.thumbNail && (
                    <p className="text-red-500 text-xs px-2 pt-1">
                      {errors.thumbNail}
                    </p>
                  )}
                </div>

                <div className="px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border">
                  <div className="flex justify-between items-center p-2 rounded-lg bg-white mb-2 border">
                    <h2 className="text-sm font-semibold">
                      Top {MAX_FEATURED_IMAGES} Showcase Images{" "}
                      <span className="text-gray-400 font-normal">
                        ({(formData.featuredImages || []).length}/
                        {MAX_FEATURED_IMAGES})
                      </span>
                    </h2>
                    <button
                      className="bg-teal-500 py-2 px-3 rounded-lg text-white text-xs"
                      type="button"
                      onClick={() => setIsFeaturedOpen(true)}
                    >
                      Choose Images
                    </button>
                  </div>
                  <p className="text-xs text-gray-500 px-1 mb-3">
                    Shown at the top of the project page. The first image is the
                    large one; drag or use the arrows to reorder. Empty slots
                    are filled from the slider images.
                  </p>
                  <SortableImagePreviewer
                    images={formData.featuredImages || []}
                    onChange={(featuredImages) =>
                      setFormData((prev) => ({ ...prev, featuredImages }))
                    }
                  />
                  {errors.featuredImages && (
                    <p className="text-red-500 text-xs px-2 pt-1">
                      {errors.featuredImages}
                    </p>
                  )}
                </div>
              </div>
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-semibold block mb-2 tracking-wider">
                    Project State :{" "}
                  </label>
                  <select
                    className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                    onChange={handleStateChange}
                    value={formData.location.state}
                  >
                    {stateList.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="text-sm font-semibold block mb-2 tracking-wider">
                    Project City :{" "}
                  </label>
                  <select
                    className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        location: {
                          ...prevData.location,
                          city: e.target.value,
                        },
                      }));
                    }}
                    value={formData.location.city}
                  >
                    <option value="" disabled>
                      Select City Name
                    </option>
                    {cityList.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border">
                  <div className="flex justify-between items-center mb-3">
                    <label className="text-sm font-semibold block tracking-wider">
                      Project Walkthrough Links :
                    </label>
                    <button
                      className="bg-teal-500 py-1.5 px-3 rounded-lg text-white text-xs flex items-center gap-1 hover:bg-teal-600 transition"
                      type="button"
                      onClick={addVirtualLink}
                    >
                      <Icon icon="ic:baseline-plus" className="text-base" />
                      Add Walkthrough Link
                    </button>
                  </div>
                  {!formData.virtualLink ||
                  formData.virtualLink.length === 0 ? (
                    <div className="p-4 border border-dashed rounded-lg text-center text-xs text-gray-500 bg-gray-50">
                      No walkthrough links added. Click &quot;Add Walkthrough
                      Link&quot; to add one.
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {formData.virtualLink.map((link, index) => (
                        <div key={index} className="flex flex-col gap-1">
                          <div className="flex items-center gap-2">
                            <input
                              type="url"
                              className="py-2 px-3 border w-full rounded-lg outline-primary-500 text-sm"
                              value={link}
                              onChange={(e) =>
                                handleVirtualLinkChange(e.target.value, index)
                              }
                              placeholder={`Enter Walkthrough Url ${index + 1}...`}
                            />
                            <button
                              type="button"
                              onClick={() => removeVirtualLink(index)}
                              className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition"
                              title="Remove Link"
                            >
                              <Icon icon="mage:trash" className="text-lg" />
                            </button>
                          </div>
                          {(errors[`virtualLink[${index}]`] ||
                            errors[`virtualLink.${index}`]) && (
                            <p className="text-red-500 text-xs px-1">
                              {errors[`virtualLink[${index}]`] ||
                                errors[`virtualLink.${index}`]}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  {errors.virtualLink &&
                    typeof errors.virtualLink === "string" && (
                      <p className="text-red-500 text-xs px-2 pt-1">
                        {errors.virtualLink}
                      </p>
                    )}
                </div>
                <div>
                  <label className="text-sm font-semibold block mb-2 tracking-wider">
                    Project Youtube Link :{" "}
                  </label>
                  <input
                    type="url"
                    className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                    value={formData.youtubeLink}
                    onChange={(e) => handleInputChange(e, "youtubeLink")}
                    placeholder="Enter Youtube Url..."
                  />
                  {errors.youtubeLink && (
                    <p className="text-red-500 text-xs px-2 pt-1">
                      {errors.youtubeLink}
                    </p>
                  )}
                </div>

                <div className="px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border">
                  {/* Header */}
                  <div className="flex justify-between items-center p-2 rounded-lg bg-white mb-4 border">
                    <h2 className="text-sm font-semibold">
                      Render vs Actual Images
                    </h2>
                    <button
                      className="bg-teal-500 py-2 px-3 rounded-lg text-white text-xs flex items-center gap-1"
                      type="button"
                      onClick={addComparison}
                    >
                      <Icon icon="ic:baseline-plus" className="text-base" />
                      Add Comparison
                    </button>
                  </div>

                  {/* Comparison pairs */}
                  {Array.from({ length: getComparisonsCount() }).map(
                    (_, compIndex) => {
                      const [imgA, imgB] = getComparisonImages(compIndex);
                      const compCount = getComparisonsCount();
                      const compError = errors[`comparison_${compIndex}`];
                      return (
                        <div
                          key={compIndex}
                          className="mb-4 border rounded-lg p-3 bg-gray-50"
                        >
                          {/* Comparison header */}
                          <div className="flex justify-between items-center mb-3">
                            <span className="text-xs font-semibold text-gray-600">
                              Comparison {compIndex + 1}
                            </span>
                            {compCount > 1 && (
                              <button
                                type="button"
                                onClick={() => removeComparison(compIndex)}
                                className="text-red-500 hover:text-red-700 text-xs flex items-center gap-1"
                              >
                                <Icon icon="mage:trash" className="text-sm" />
                                Remove
                              </button>
                            )}
                          </div>

                          {/* Two slots: Render + Actual */}
                          <div className="grid grid-cols-2 gap-3">
                            {["Actual", "Render"].map(
                              (slotLabel, slotIndex) => {
                                const img = slotIndex === 0 ? imgA : imgB;
                                return (
                                  <div
                                    key={slotIndex}
                                    className="flex flex-col gap-2"
                                  >
                                    <span className="text-xs font-medium text-gray-500">
                                      {slotLabel}
                                    </span>
                                    {img ? (
                                      <div className="relative h-28 rounded-lg overflow-hidden border">
                                        <ImgOptimized
                                          src={`${process.env.REACT_APP_BACK_URL}/api/minio/${img}${getMinioSize()}`}
                                          alt={slotLabel}
                                          className="w-full h-full object-cover"
                                        />
                                        <button
                                          type="button"
                                          onClick={() =>
                                            setComparisonSlot(
                                              compIndex,
                                              slotIndex,
                                              null,
                                            )
                                          }
                                          className="absolute top-1 right-1 bg-red-500 text-white rounded-full size-5 flex items-center justify-center"
                                        >
                                          <Icon
                                            icon="humbleicons:times"
                                            className="text-xs"
                                          />
                                        </button>
                                      </div>
                                    ) : (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          openBeforeAfterSlot(
                                            compIndex,
                                            slotIndex,
                                          )
                                        }
                                        className="h-28 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center gap-1 text-gray-400 hover:border-teal-400 hover:text-teal-500 transition-colors"
                                      >
                                        <Icon
                                          icon="ic:baseline-add-photo-alternate"
                                          className="text-2xl"
                                        />
                                        <span className="text-xs">
                                          Choose {slotLabel}
                                        </span>
                                      </button>
                                    )}
                                  </div>
                                );
                              },
                            )}
                          </div>

                          {compError && (
                            <p className="text-red-500 text-xs mt-2">
                              {compError}
                            </p>
                          )}
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Image Selection Section */}
          <div className="px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border">
            <div className="flex justify-between items-center px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border">
              <h2 className="text-lg font-bold">
                Top Images <span className="text-red-500">*</span>
              </h2>
              <button
                className="bg-teal-500 py-2 px-3 rounded-lg text-white"
                type="button"
                onClick={openImageSelector}
              >
                Choose Images
              </button>
            </div>

            <ImagePreviewer
              images={formData.projectImages}
              selectedImages={formData.sliderImages}
              removeImage={(index) => removeImage(index, 1)}
            />
            {errors.sliderImages && (
              <p className="text-red-500 text-xs px-2 pt-1">
                {errors.sliderImages}
              </p>
            )}
          </div>

          <div className="my-5 flex justify-between items-center">
            <h2 className="text-xl font-semibold">Dynamic Text Sections</h2>
            <button
              className="bg-teal-500 py-2 px-3 rounded-lg text-white"
              type="button"
              onClick={addSection}
            >
              Add Text Section
            </button>
          </div>
          {/* Text Sections */}
          {formData.textSection.map((section, index) => (
            <div
              key={index}
              className="px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border"
            >
              <div className="flex items-center justify-between mb-3">
                <h2 className="text-lg font-bold">Section {index + 1}</h2>
                <div className="flex gap-3">
                  <ToggleButton
                    value={section.isActive}
                    onChange={() => handleToggle(index)}
                  />
                  <button
                    className="bg-red-500 py-2 px-3 rounded-lg text-white"
                    type="button"
                    onClick={() => removeSection(index)}
                  >
                    Remove
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <div>
                    <label className="text-sm font-semibold block mb-2 tracking-wider">
                      Section Title <span className="text-red-500">*</span>{" "}
                      :{" "}
                    </label>
                    <input
                      className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                      value={section.title}
                      onChange={(e) => handleSectionChange(e, index, "title")}
                      placeholder="Enter section title..."
                    />
                    {errors[`textSection[${index}].title`] && (
                      <p className="text-red-500 text-xs px-2 pt-1">
                        {errors[`textSection[${index}].title`]}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="text-sm font-semibold block mb-2 tracking-wider">
                      Section Description{" "}
                      <span className="text-red-500">*</span> :{" "}
                    </label>
                    <textarea
                      className="py-2 px-3 border w-full rounded-lg outline-primary-500 text-md"
                      value={section.description}
                      rows={6}
                      onChange={(e) =>
                        handleSectionChange(e, index, "description")
                      }
                      placeholder="Enter section description..."
                    />
                    {errors[`textSection[${index}].description`] && (
                      <p className="text-red-500 text-xs px-2 pt-1">
                        {errors[`textSection[${index}].description`]}
                      </p>
                    )}
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <label className="text-sm font-semibold block mb-2 tracking-wider">
                      Section Sub Title <span className="text-red-500">*</span>{" "}
                      :{" "}
                    </label>
                    <input
                      className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                      value={section.subTitle}
                      onChange={(e) =>
                        handleSectionChange(e, index, "subTitle")
                      }
                      placeholder="Enter section subtitle..."
                    />
                    {errors[`textSection[${index}].subTitle`] && (
                      <p className="text-red-500 text-xs px-2 pt-1">
                        {errors[`textSection[${index}].subTitle`]}
                      </p>
                    )}
                  </div>

                  <div className="flex justify-between items-center p-2 rounded-lg bg-white border">
                    <h2 className="text-sm font-bold">
                      Section Images <span className="text-red-500">*</span>
                    </h2>
                    <button
                      className="bg-teal-500 py-2 px-3 rounded-lg text-white text-xs"
                      type="button"
                      onClick={() => openTextSectionImageSelector(index)}
                    >
                      Choose Images
                    </button>
                  </div>

                  <ImagePreviewer
                    images={formData.projectImages}
                    grid={4}
                    selectedImages={section.textSectionImgs}
                    removeImage={(imgIndex) =>
                      removeImage(imgIndex, false, index)
                    }
                  />
                </div>

                {errors[`textSection[${index}].textSectionImgs`] && (
                  <p className="text-red-500 text-xs px-2 pt-1">
                    {errors[`textSection[${index}].textSectionImgs`]}
                  </p>
                )}
              </div>
            </div>
          ))}

          <div className="mt-8 gap-3 flex items-center justify-between">
            <Link
              // to={`/project-showcase/${id}/re-upload`}
              to={`re-upload`}
              className="py-2 text-sm px-2 bg-teal-500 rounded-lg text-white"
              // type="submit"
            >
              Re-Upload Images
            </Link>

            <div className="flex gap-4 items-center">
              <MyToggle
                checked={formData?.isFavorite}
                onChange={(val) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    isFavorite: val,
                  }))
                }
              />
              <ToggleButton
                value={formData?.isLive}
                label="Make Live"
                onChange={() =>
                  setFormData((prev) => ({ ...prev, isLive: !prev.isLive }))
                }
              />
              <button
                className="py-2 px-4 text-sm bg-teal-500 hover:bg-teal-600 rounded-lg text-white font-medium flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed transition"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <svg
                    className="animate-spin h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    />
                  </svg>
                )}
                {isSubmitting ? "Submitting..." : "Submit Project"}
              </button>
            </div>
          </div>
        </form>
      </div>

      {isImageSelectorOpen && (
        <ImageSelectorPopup
          images={formData.projectImages} // Provide images to select from
          selectedImages={formData.sliderImages} // Pass selectedImages state
          imageTags={formData.imageTags || projectData?.imageTags || []}
          onTagChange={handleTagChange}
          onChange={(selectedImages) =>
            handleImageSelectionChange(selectedImages, 1)
          } // Handle image selection change
          onClose={closeImageSelector} // Close popup function
        />
      )}

      {activeComparisonSlot !== null && (
        <ImageSelectorPopup
          images={formData.projectImages}
          selectedImages={(() => {
            const img = getComparisonImages(activeComparisonSlot.compIndex)[
              activeComparisonSlot.slotIndex
            ];
            return img ? [img] : [];
          })()}
          imageTags={formData.imageTags || projectData?.imageTags || []}
          onTagChange={handleTagChange}
          isSingle={true}
          onChange={(selected) => {
            setComparisonSlot(
              activeComparisonSlot.compIndex,
              activeComparisonSlot.slotIndex,
              selected[0] || null,
            );
          }}
          onClose={closeBeforeAfterSlot}
        />
      )}

      {isThumbNailOpen && (
        <ImageSelectorPopup
          images={formData.projectImages} // Provide images to select from
          selectedImages={formData.thumbNail} // Pass selectedImages state
          imageTags={formData.imageTags || projectData?.imageTags || []}
          onTagChange={handleTagChange}
          onChange={(selectedImages) =>
            handleImageSelectionChange(selectedImages, 3)
          } // Handle image selection change
          onClose={closeThumbNail} // Close popup function
          isSingle={true}
        />
      )}

      {isFeaturedOpen && (
        <ImageSelectorPopup
          images={formData.projectImages}
          selectedImages={formData.featuredImages || []}
          imageTags={formData.imageTags || projectData?.imageTags || []}
          onTagChange={handleTagChange}
          maxSelect={MAX_FEATURED_IMAGES}
          onChange={(featuredImages) =>
            setFormData((prev) => ({ ...prev, featuredImages }))
          }
          onClose={() => setIsFeaturedOpen(false)}
        />
      )}

      {isTextSectionImageSelectorOpen && (
        <ImageSelectorPopup
          images={formData.projectImages} // Provide images to select from
          selectedImages={
            formData.textSection[currentSectionIndex]?.textSectionImgs || []
          } // Pass selectedImages state for current section
          imageTags={formData.imageTags || projectData?.imageTags || []}
          onTagChange={handleTagChange}
          onChange={(selectedImages) =>
            handleImageSelectionChange(selectedImages, false)
          } // Handle image selection change
          onClose={closeTextSectionImageSelector} // Close popup function
        />
      )}
      <OtpPopup
        isActive={isOtpPopupActive}
        otp={formData.otp}
        setOtp={(otp) => setFormData((prev) => ({ ...prev, otp }))}
        closePopup={() => setIsOtpPopupActive(false)}
        handleSubmit={() => {
          if (!formData.otp || formData.otp.length < 6) {
            toast.error("Please enter a valid OTP");
            return;
          }
          postData(toast.loading("Submitting OTP..."));
        }} // Pass the toastId to postData
        projectId={projectData?._id}
      />
    </div>
  );
};

const ImageSelectorPopup = ({
  images = [],
  selectedImages = [],
  imageTags = [],
  onTagChange,
  onChange,
  onClose,
  isSingle = false,
  maxSelect,
}) => {
  const [activeTag, setActiveTag] = useState("all");

  const getTagForImage = (img) => {
    const match = imageTags.find((t) => t.image === img);
    return match ? match.tag : "actual";
  };

  const filteredImages = images.filter((img) => {
    if (activeTag === "all") return true;
    // if (activeTag === "untagged") return !getTagForImage(img);
    return getTagForImage(img) === activeTag;
  });

  const getCountForTag = (tagOption) => {
    if (tagOption === "all") return images.length;
    // if (tagOption === "untagged")
    //   return images.filter((img) => !getTagForImage(img)).length;
    return images.filter((img) => getTagForImage(img) === tagOption).length;
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (isSingle) {
      onChange(checked ? [value] : []);
    } else if (checked) {
      if (maxSelect && selectedImages.length >= maxSelect) {
        toast.info(`You can select up to ${maxSelect} images`);
        return;
      }
      onChange([...selectedImages, value]); // Add image to selectedImages
    } else {
      onChange(selectedImages.filter((img) => img !== value)); // Remove image from selectedImages
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center pop-backdrop"
      onClick={onClose}
    >
      <div className="fixed inset-0">
        <div className="flex items-center justify-center min-h-screen px-4">
          <div
            className="relative w-full max-w-5xl mx-auto rounded-lg shadow bg-white dark:bg-gray-700"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal header */}
            <div className="flex items-center justify-between px-5 pt-4 pb-2 border-b">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-gray-700 dark:text-gray-200">
                  Filter by Tag:
                </span>
                <div className="inline-flex rounded-lg border border-gray-200 p-1 bg-gray-50">
                  {/* {["all", "actual", "render", "untagged"].map((tagOption) => { */}
                  {["all", "actual", "render"].map((tagOption) => {
                    const count = getCountForTag(tagOption);
                    return (
                      <button
                        key={tagOption}
                        type="button"
                        onClick={() => setActiveTag(tagOption)}
                        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors capitalize ${
                          activeTag === tagOption
                            ? "bg-primary-500 text-white shadow-sm"
                            : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                        }`}
                      >
                        {tagOption} ({count})
                      </button>
                    );
                  })}
                </div>
              </div>
              <button
                onClick={onClose}
                type="button"
                className="bg-[#efefef] hover:bg-gray-200 hover:text-gray-900 rounded-full text-sm w-8 h-8 inline-flex justify-center items-center"
              >
                <Unicons.UilTimes />
              </button>
            </div>
            {/* Modal body */}
            <div className="p-5 h-[75vh] overflow-y-auto">
              <ResponsiveMasonry
                columnsCountBreakPoints={{ 350: 2, 600: 3, 950: 5, 900: 6 }}
              >
                <Masonry gutter={"0.5rem"}>
                  {filteredImages?.map((option, index) => (
                    <div key={index} className="relative mb-2">
                      <input
                        type="checkbox"
                        value={option}
                        checked={selectedImages.includes(option)}
                        onChange={handleCheckboxChange} // Use handleCheckboxChange function
                        id={option}
                        name="checkbox-group"
                        className="hidden"
                      />
                      <label
                        htmlFor={option}
                        className="w-full cursor-pointer relative block"
                      >
                        <ImgOptimized
                          src={`${process.env.REACT_APP_BACK_URL}/api/minio/${option}${getMinioSize()}`}
                          alt={option}
                          className="rounded-xl border-2 shadow-lg w-full"
                        />
                        <div
                          className="absolute bottom-2 left-2 flex items-center gap-1 z-20"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <select
                            value={getTagForImage(option) || "actual"}
                            onChange={(e) => {
                              e.stopPropagation();
                              const newTag = e.target.value;
                              if (onTagChange) {
                                onTagChange(option, newTag);
                              }
                            }}
                            className="bg-black/75 hover:bg-black text-white text-[10px] px-1.5 py-0.5 rounded capitalize font-medium cursor-pointer border border-white/20 outline-none"
                          >
                            {/* <option
                              value="untagged"
                              className="bg-gray-800 text-white"
                            >
                              Untagged
                            </option> */}
                            <option
                              value="actual"
                              className="bg-gray-800 text-white"
                            >
                              Actual
                            </option>
                            <option
                              value="render"
                              className="bg-gray-800 text-white"
                            >
                              Render
                            </option>
                          </select>
                        </div>
                        {selectedImages.includes(option) &&
                          (maxSelect ? (
                            <div className="absolute top-[10px] left-[10px] z-10 bg-green-500 rounded-full size-6 flex items-center justify-center text-white text-xs font-bold">
                              {selectedImages.indexOf(option) + 1}
                            </div>
                          ) : (
                            <div className="absolute top-[10px] left-[10px] z-10 bg-green-400 rounded-full flex items-center justify-center text-white">
                              <Unicons.UilCheckCircle />
                            </div>
                          ))}
                      </label>
                    </div>
                  ))}
                </Masonry>
              </ResponsiveMasonry>
            </div>
            {/* Modal footer */}
            <div className="flex items-center justify-end p-5 pt-1 rounded-b gap-3">
              <button
                type="button"
                onClick={onClose}
                className="text-white text-sm bg-green-500 hover:bg-green-600 py-2 px-8 rounded-lg"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ImagePreviewer = ({
  images,
  selectedImages = [],
  grid = 10,
  removeImage,
  isSingle = false,
}) => {
  const { isSuperAdmin } = useRole();
  return (
    <div className="border w-full rounded-lg p-4 min-h-[100px] max-h-[500px] overflow-y-auto bg-white">
      <div
        className="grid gap-2"
        style={{
          gridTemplateColumns: `repeat(${grid}, minmax(0, 1fr))`,
        }}
      >
        {selectedImages.map((file, index) => (
          <div key={index} className="relative h-20">
            <ImgOptimized
              src={`${process.env.REACT_APP_BACK_URL}/api/minio/${file}${getMinioSize()}`}
              alt={`Selected ${index}`}
              className="w-full h-20 object-cover rounded"
            />
            {isSuperAdmin && (
              <Icon
                onClick={() => removeImage(index)}
                className="absolute top-1 right-1 bg-red-500 text-white rounded-full size-5 text-center p-1"
                icon="mage:trash"
              />
            )}
          </div>
        ))}
        {!selectedImages.length && (
          <div className="w-full h-full grid place-content-center">
            <ImgOptimized
              className="w-[200px]"
              src={ImgDrop}
              alt="No images selected"
            />
          </div>
        )}
      </div>
    </div>
  );
};

const OtpPopup = ({
  isActive,
  otp,
  setOtp,
  closePopup,
  handleSubmit,
  projectId,
}) => {
  console.log("ISACTIVE", isActive);
  const [isLoad, setIsLoad] = useState(false);
  const handleChange = (e) => {
    // Limit OTP to numeric and max length 6
    const value = e.target.value.replace(/\D/g, "");
    setOtp(value.slice(0, 6));
  };

  const sendOtp = async () => {
    try {
      setIsLoad(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases/project-otp`,
        { projectId },
        getAxiosConfig(),
      );
      toast.success("OTP sent successfully!");
    } catch (error) {
      console.log(error?.message);
      toast.error("Failed to send OTP");
    } finally {
      setIsLoad(false);
    }
  };
  if (!isActive) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      {/* Popup Card */}
      <div className="bg-white rounded-lg shadow-lg w-full max-w-sm p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-teal-600">Enter OTP</h2>
          <button
            onClick={closePopup}
            className="text-gray-400 hover:text-teal-600 transition"
          >
            ✕
          </button>
        </div>

        {/* Input */}
        <input
          type="text"
          value={otp}
          onChange={handleChange}
          placeholder="Enter your OTP"
          className="w-full border border-teal-300 focus:border-teal-500 rounded-md px-4 py-2 mb-4 outline-none"
        />

        {/* Actions */}
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={sendOtp}
            disabled={isLoad}
            className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700 transition basis-1/2 disabled:cursor-not-allowed"
          >
            Send OTP
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="px-4 py-2 rounded-md bg-teal-500 hover:bg-teal-600 text-white transition basis-1/2"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectShowcaseAdd;
